/**
 * File generated by js-routes 2.3.0
 * Based on Rails 7.1.3.2 routes of TheGoat::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {"protocol":"https","host":"launchnotes.io","port":null},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (keyword_parameters.anchor) {
                result += "#" + keyword_parameters.anchor;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("ESM", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{},
    });
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:announcement_id/framed_show(.:format)
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const announcement_framed_show_path = /*#__PURE__*/ __jsr.r({"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"framed_show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/atlassian/auth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_atlassian_auth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"atlassian"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/atlassian/auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_atlassian_auth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"atlassian"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/atlassian/auth/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_atlassian_auth_refresh_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"atlassian"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/esp/auth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_esp_auth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"esp"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/esp/auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_esp_auth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"esp"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/esp/auth/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_esp_auth_refresh_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"esp"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/hubspot/auth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_hubspot_auth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/hubspot/auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_hubspot_auth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/hubspot/auth/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_hubspot_auth_refresh_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"hubspot"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/intercom/auth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_intercom_auth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"intercom"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/intercom/auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_intercom_auth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"intercom"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/intercom/auth/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_intercom_auth_refresh_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"intercom"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/jira/auth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_jira_auth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/jira/auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_jira_auth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/jira/auth/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_jira_auth_refresh_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"jira"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/slack/auth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_slack_auth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/slack/auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_slack_auth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/slack/auth/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_slack_auth_refresh_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/slack_command/auth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_slack_command_auth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"slack_command"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/slack_command/auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_slack_command_auth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"slack_command"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/slack_command/auth/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_slack_command_auth_refresh_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"slack_command"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/:app_class/webhooks/:handler(.:format)
 * @param {any} app_class
 * @param {any} handler
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_webhook_consume_path = /*#__PURE__*/ __jsr.r({"app_class":{"r":true},"handler":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[3,"app_class"],[2,[7,"/"],[2,[6,"webhooks"],[2,[7,"/"],[2,[3,"handler"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/zapier/auth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_zapier_auth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"zapier"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/zapier/auth/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_zapier_auth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"zapier"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /apps/zapier/auth/refresh_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apps_zapier_auth_refresh_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"zapier"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth_failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auth_failure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth_failure"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /authorize_callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorize_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"authorize_callback"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /board(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const board_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"board"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const direct_unsubscribe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /embed/announcement_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_announcement_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"announcement_list"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /embed/announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_announcements_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /embed/unread(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_unread_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /embed/unread(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_unread_get_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/announcements/:announcement_id(.:format)
 * @param {any} embed_id
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_announcement_show_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/announcements(.:format)
 * @param {any} embed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_announcements_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/feedbacks(.:format)
 * @param {any} embed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_feedbacks_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/feedbacks/create(.:format)
 * @param {any} embed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_feedbacks_create_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/ideas/:idea_id(.:format)
 * @param {any} embed_id
 * @param {any} idea_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_idea_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"idea_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"idea_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/ideas(.:format)
 * @param {any} embed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_ideas_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"ideas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id(.:format)
 * @param {any} embed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_info_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/roadmap(.:format)
 * @param {any} embed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_roadmap_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"roadmap"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/track/unread(.:format)
 * @param {any} embed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_track_unread_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"track"],[2,[7,"/"],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/track/view(.:format)
 * @param {any} embed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_track_view_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"track"],[2,[7,"/"],[2,[6,"view"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/v2/:embed_id/roadmap/:work_item_id(.:format)
 * @param {any} embed_id
 * @param {any} work_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_v2_work_item_path = /*#__PURE__*/ __jsr.r({"embed_id":{"r":true},"work_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[3,"embed_id"],[2,[7,"/"],[2,[6,"roadmap"],[2,[7,"/"],[2,[3,"work_item_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /feed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const feedbacks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /graphiql
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphiql_rails_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"graphiql"]]);

/**
 * Generates rails route to
 * /graphql(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const graphql_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"graphql"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /slack_apps/handle_message(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const handle_message_slack_apps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"slack_apps"],[2,[7,"/"],[2,[6,"handle_message"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /slack_apps/handle_oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const handle_oauth_slack_apps_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"slack_apps"],[2,[7,"/"],[2,[6,"handle_oauth"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /slack/v2/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const handle_slack_announcements_auth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /slack-oauth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const handle_slack_oauth_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"slack-oauth"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ideas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const idea_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ideas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ideas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ideas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /moments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const moments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"moments"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /okcomputer(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputer_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"okcomputer"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /okcomputerdbs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const okcomputerdbs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"okcomputerdbs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /updates/one_click_unsubscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const one_click_unsubscribe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[6,"one_click_unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /postmark/bounce(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postmark_bounce_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"bounce"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /announcements/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_announcement_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing/activate(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_activate_billing_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing/activate_free(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_activate_free_billing_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"activate_free"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/secure/admin_portal(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_admin_portal_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"secure"],[2,[7,"/"],[2,[6,"admin_portal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/announcement_digests/:announcement_digest_id/send_preview_email(.:format)
 * @param {any} project_id
 * @param {any} announcement_digest_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_announcement_digest_send_announcement_digest_preview_email_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"announcement_digest_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"announcement_digests"],[2,[7,"/"],[2,[3,"announcement_digest_id"],[2,[7,"/"],[2,[6,"send_preview_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/announcements/:announcement_id/publish_test(.:format)
 * @param {any} project_id
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_announcement_publish_test_announcement_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"publish_test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/announcements/:announcement_id/send_preview_email(.:format)
 * @param {any} project_id
 * @param {any} announcement_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_announcement_send_announcement_preview_email_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"announcement_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"announcement_id"],[2,[7,"/"],[2,[6,"send_preview_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/apps/:id(.:format)
 * @param {any} project_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_app_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/apps(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_apps_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_billing_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing/cancel(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_cancel_billing_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing/change/:plan_id(.:format)
 * @param {any} project_id
 * @param {any} plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_change_billing_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"change"],[2,[7,"/"],[2,[3,"plan_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/editor_blobs/:signed_id(.:format)
 * @param {any} project_id
 * @param {any} signed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_editor_blob_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"signed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"editor_blobs"],[2,[7,"/"],[2,[3,"signed_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/extract_file_text(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_extract_file_text_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"extract_file_text"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/owner/:owner_id/fetch_text_completion(.:format)
 * @param {any} project_id
 * @param {any} owner_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_fetch_text_completion_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"owner_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"owner"],[2,[7,"/"],[2,[3,"owner_id"],[2,[7,"/"],[2,[6,"fetch_text_completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/flatfile/authenticate(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_flatfile_authenticate_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"flatfile"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /project_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_list_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"project_list"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/billing/new_intent/:plan_id(.:format)
 * @param {any} project_id
 * @param {any} plan_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_new_billing_intent_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"plan_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"billing"],[2,[7,"/"],[2,[6,"new_intent"],[2,[7,"/"],[2,[3,"plan_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/owner/:owner_id/process_text_completion(.:format)
 * @param {any} project_id
 * @param {any} owner_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_process_text_completion_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"owner_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"owner"],[2,[7,"/"],[2,[3,"owner_id"],[2,[7,"/"],[2,[6,"process_text_completion"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/secure/regenerate_rss_secret_key(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_regenerate_rss_secret_key_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"secure"],[2,[7,"/"],[2,[6,"regenerate_rss_secret_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /projects/:project_id/apps/user_apps(.:format)
 * @param {any} project_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_user_apps_path = /*#__PURE__*/ __jsr.r({"project_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"projects"],[2,[7,"/"],[2,[3,"project_id"],[2,[7,"/"],[2,[6,"apps"],[2,[7,"/"],[2,[6,"user_apps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v/:project_view_slug/board(.:format)
 * @param {any} project_view_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_view_board_path = /*#__PURE__*/ __jsr.r({"project_view_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"project_view_slug"],[2,[7,"/"],[2,[6,"board"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v/:project_view_slug/check_your_inbox(.:format)
 * @param {any} project_view_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_view_check_your_inbox_path = /*#__PURE__*/ __jsr.r({"project_view_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"project_view_slug"],[2,[7,"/"],[2,[6,"check_your_inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v/:project_view_slug/sessions/create(.:format)
 * @param {any} project_view_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_view_create_session_path = /*#__PURE__*/ __jsr.r({"project_view_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"project_view_slug"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v/:project_view_slug/login(.:format)
 * @param {any} project_view_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_view_login_path = /*#__PURE__*/ __jsr.r({"project_view_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"project_view_slug"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v/:project_view_slug/login(.:format)
 * @param {any} project_view_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_view_send_link_path = /*#__PURE__*/ __jsr.r({"project_view_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"project_view_slug"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v/:project_view_slug/board/:id(.:format)
 * @param {any} project_view_slug
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_view_work_item_path = /*#__PURE__*/ __jsr.r({"project_view_slug":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"project_view_slug"],[2,[7,"/"],[2,[6,"board"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v/:project_view_slug/board(.:format)
 * @param {any} project_view_slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const project_view_work_items_root_path = /*#__PURE__*/ __jsr.r({"project_view_slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v"],[2,[7,"/"],[2,[3,"project_view_slug"],[2,[7,"/"],[2,[6,"board"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_assets/:signed_id(.:format)
 * @param {any} signed_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_secure_asset_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"secure_assets"],[2,[7,"/"],[2,[3,"signed_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /public/subscribers/show(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const public_subscribers_show_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"show"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_connections/:id/regenerate_secret_key(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_secret_key_secure_connection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"secure_connections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"regenerate_secret_key"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /secure_connections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secure_connection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"secure_connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /auth/set_user_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_user_context_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"set_user_context"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stripe-webhooks
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_event_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"stripe-webhooks"]]);

/**
 * Generates rails route to
 * /stripe-webhooks/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_event_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"stripe-webhooks"]],[7,"/"]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/project_subscriptions/:id(.:format)
 * @param {any} subscriber_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_project_subscription_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"project_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/project_subscriptions/:project_subscription_id/project_subscription_transports/:id(.:format)
 * @param {any} subscriber_id
 * @param {any} project_subscription_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_project_subscription_project_subscription_transport_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"project_subscription_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"project_subscriptions"],[2,[7,"/"],[2,[3,"project_subscription_id"],[2,[7,"/"],[2,[6,"project_subscription_transports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/project_subscriptions/:project_subscription_id/project_subscription_transports(.:format)
 * @param {any} subscriber_id
 * @param {any} project_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_project_subscription_project_subscription_transports_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"project_subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"project_subscriptions"],[2,[7,"/"],[2,[3,"project_subscription_id"],[2,[7,"/"],[2,[6,"project_subscription_transports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/project_subscriptions/:project_subscription_id/project_subscription_work_items/:id(.:format)
 * @param {any} subscriber_id
 * @param {any} project_subscription_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_project_subscription_project_subscription_work_item_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"project_subscription_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"project_subscriptions"],[2,[7,"/"],[2,[3,"project_subscription_id"],[2,[7,"/"],[2,[6,"project_subscription_work_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/project_subscriptions/:project_subscription_id/project_subscription_work_items(.:format)
 * @param {any} subscriber_id
 * @param {any} project_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_project_subscription_project_subscription_work_items_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"project_subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"project_subscriptions"],[2,[7,"/"],[2,[3,"project_subscription_id"],[2,[7,"/"],[2,[6,"project_subscription_work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/project_subscriptions/:project_subscription_id/resubscribe(.:format)
 * @param {any} subscriber_id
 * @param {any} project_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_project_subscription_resubscribe_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"project_subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"project_subscriptions"],[2,[7,"/"],[2,[3,"project_subscription_id"],[2,[7,"/"],[2,[6,"resubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/project_subscriptions/:project_subscription_id/unsubscribe(.:format)
 * @param {any} subscriber_id
 * @param {any} project_subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_project_subscription_unsubscribe_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"project_subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"project_subscriptions"],[2,[7,"/"],[2,[3,"project_subscription_id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/subscriptions/:id(.:format)
 * @param {any} subscriber_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_subscription_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers/:subscriber_id/subscriptions(.:format)
 * @param {any} subscriber_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscriber_subscriptions_path = /*#__PURE__*/ __jsr.r({"subscriber_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"subscriber_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tiptap/webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tiptap_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tiptap"],[2,[7,"/"],[2,[6,"webhook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /ideas/:id/toggle_vote(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggle_vote_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_vote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /embed/announcements/track_open(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const track_open_embed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"embed"],[2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"track_open"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /translations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const translations_template_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"admin"]]);

/**
 * Generates rails route to
 * /admin/sidekiq/web
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"sidekiq"],[2,[7,"/"],[6,"web"]]]]);

/**
 * Generates rails route to
 * /admin/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/announcements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_announcements_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_announcements_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/announcements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_announcements_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/administrators/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_deactivate_auth_administrators_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"auth"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/administrators/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_reactivate_auth_administrators_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"auth"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/administrators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_auth_administrators_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"auth"],[2,[7,"/"],[2,[6,"administrators"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/administrators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_auth_administrators_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"auth"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/administrators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_auth_administrators_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"auth"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/auth/administrators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_auth_administrators_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"auth"],[2,[7,"/"],[2,[6,"administrators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_categories_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_categories_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_categories_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_categories_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/events(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_events_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_events_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/events/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_events_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_gates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_feature_gates_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"feature_gates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/feature_gates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_feature_gates_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"feature_gates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_gates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_feature_gates_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"feature_gates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/feature_gates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_feature_gates_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"feature_gates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/feedbacks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_feedbacks_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/feedbacks/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_feedbacks_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"feedbacks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/feedbacks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_feedbacks_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"feedbacks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/feedbacks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_feedbacks_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"feedbacks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_organizations_ideas_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:id/create_feedback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_create_feedback_ideas_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_publish_ideas_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_ideas_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"ideas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_ideas_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"ideas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_ideas_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ideas/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_ideas_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"ideas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/mail_app_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_mail_app_settings_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"mail_app_settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/mail_app_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_mail_app_settings_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"mail_app_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/mail_app_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_mail_app_settings_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"mail_app_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/mail_app_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_mail_app_settings_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"mail_app_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketplace_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_marketplace_template_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"marketplace_template"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/marketplace_template/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_marketplace_template_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"marketplace_template"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketplace_template/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_marketplace_template_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"marketplace_template"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/marketplace_template/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_marketplace_template_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"marketplace_template"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_feature_pivots(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_organization_feature_pivots_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organization_feature_pivots"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/organization_feature_pivots/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_organization_feature_pivots_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organization_feature_pivots"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_feature_pivots/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_organization_feature_pivots_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organization_feature_pivots"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organization_feature_pivots/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_organization_feature_pivots_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organization_feature_pivots"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/activate_community(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_activate_community_organizations_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate_community"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/new_signup(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_signup_organizations_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"new_signup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_deactivate_organizations_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_reactivate_organizations_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/sync_subscription(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_sync_subscription_organizations_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sync_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_organizations_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_organizations_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_organizations_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_organizations_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/announcements(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_announcements_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/events(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_events_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/subscribers(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_subscribers_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/provision_ingress(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_provision_ingress_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provision_ingress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/delete_ingress(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_delete_ingress_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_ingress"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_deactivate_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_reactivate_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/provision_secure_connection(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_provision_secure_connection_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provision_secure_connection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/provision_admin_portal_link(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_provision_admin_portal_link_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"provision_admin_portal_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:projects_admin_id/create(.:format)
 * @param {any} projects_admin_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_projects_admin_create_path = /*#__PURE__*/ __jsr.r({"projects_admin_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"projects_admin_id"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/update_powered_by_position(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_update_powered_by_position_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_powered_by_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_projects_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/projects/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_projects_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/projects/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_projects_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"projects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/roles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_roles_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/roles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_roles_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/secure_connections/:id/generate_new_secret(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_generate_new_secret_secure_connections_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"secure_connections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"generate_new_secret"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/secure_connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_secure_connections_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"secure_connections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/secure_connections/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_secure_connections_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"secure_connections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/secure_connections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_secure_connections_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"secure_connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_coupons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_stripe_coupons_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_coupons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_coupons/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_stripe_coupons_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_coupons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_coupons/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_stripe_coupons_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_coupons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_coupons/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_stripe_coupons_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_coupons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_stripe_customers_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_customers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_customers/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_stripe_customers_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_customers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_customers/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_stripe_customers_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_customers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_customers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_stripe_customers_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_customers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_plans/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_deactivate_stripe_plans_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_plans/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_activate_stripe_plans_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_plans(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_stripe_plans_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_plans"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_plans/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_stripe_plans_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_plans"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_plans/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_stripe_plans_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_plans"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_plans/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_stripe_plans_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_plans"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_stripe_subscriptions_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_subscriptions/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_stripe_subscriptions_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_stripe_subscriptions_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/stripe_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_stripe_subscriptions_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"stripe_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id/unblock(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_unblock_subscribers_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unblock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_subscribers_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/subscribers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_subscribers_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sidekiq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_trestle_sidekiq_sidekiq_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"sidekiq"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/reactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_reactivate_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/deactivate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_deactivate_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/unblock(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_unblock_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unblock"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_confirm_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/trigger_pw_reset(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_trigger_pw_reset_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trigger_pw_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/remove_project_role(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_remove_project_role_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_project_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/remove_organization_role(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_remove_organization_role_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_organization_role"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/create_organization_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_create_organization_user_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_organization_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/create_organization_admin(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_create_organization_admin_users_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_organization_admin"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_users_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_users_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_items(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_work_items_admin_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/work_items/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_new_work_items_admin_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_items/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_edit_work_items_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/work_items/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_work_items_admin_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"admin"]],[7,"/"]],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trestle_root_path = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"admin"]],[7,"/"]]);

/**
 * Generates rails route to
 * /recede_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_recede_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /refresh_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_refresh_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /resume_historical_location(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const turbo_resume_historical_location_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /unauthorized(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unauthorized_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"unauthorized"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /under_construction(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const under_construction_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"under_construction"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /updates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /updates/check_your_inbox(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_check_your_inbox_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[6,"check_your_inbox"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /updates/generate_new_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_generate_new_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[6,"generate_new_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /updates/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /updates/login_expired(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_login_expired_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[6,"login_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /updates/logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /translations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upload_translations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"translations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /userinfo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userinfo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"userinfo"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/auth/refresh(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_refresh_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"refresh"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/set_user_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_set_user_context_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"set_user_context"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/workos/authenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_workos_authenticate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"workos"],[2,[7,"/"],[2,[6,"authenticate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/workos/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_workos_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"workos"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_connections/:id/verify_auth_token(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_auth_token_secure_connection_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"secure_connections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify_auth_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /board/:work_item_id(.:format)
 * @param {any} work_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_item_path = /*#__PURE__*/ __jsr.r({"work_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"board"],[2,[7,"/"],[2,[3,"work_item_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /board/:work_item_id/feed(.:format)
 * @param {any} work_item_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const work_item_feed_path = /*#__PURE__*/ __jsr.r({"work_item_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"board"],[2,[7,"/"],[2,[3,"work_item_id"],[2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

